// extracted by mini-css-extract-plugin
var _1 = "DocFlowSendingEpostContent-modulecontent__Kedst DocFlowSendingWidgetContent-moduleDocFlowSendingWidgetContent__dZXYj";
var _2 = "DocFlowSendingEpostContent-moduleformContent__ZrTEp";
var _3 = "DocFlowSendingEpostContent-modulenoSettings__Ijo7u DocFlowSendingWidgetContent-moduleDocFlowSendingWidgetContent__dZXYj";
export { _1 as "content", _2 as "formContent", _3 as "noSettings" }
